module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    ref: "modifymyinfo",
    staticClass: "modifymyinfo"
  }, [_c('div', {
    staticClass: "modifymyinfo-wrapper"
  }, [_c('div', {
    staticClass: "modifymyinfo-wrapper-auot"
  }, [_c('span', {
    staticClass: "modifymyinfotet"
  }, [_vm._v(_vm._s(_vm.$t('mydescription')))]), _vm._v(" "), _c('div', {
    staticClass: "modifyUserdata"
  }, [_c('div', {
    staticClass: "modifyUserdata-str"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('description')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modifymyinfoobj.description),
      expression: "modifymyinfoobj.description"
    }],
    staticClass: "modifyUserdata-input",
    domProps: {
      "value": (_vm.modifymyinfoobj.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.modifymyinfoobj, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modifyUserdata"
  }, [_c('div', {
    staticClass: "modifyUserdata-str"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('username')) + "：")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modifymyinfoobj.id),
      expression: "modifymyinfoobj.id"
    }],
    staticClass: "modifyUserdata-input",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.modifymyinfoobj.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.modifymyinfoobj, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modifyUserdata"
  }, [_c('div', {
    staticClass: "modifyUserdata-str"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('password')) + "：")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modifymyinfoobj.pw),
      expression: "modifymyinfoobj.pw"
    }],
    staticClass: "modifyUserdata-input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.modifymyinfoobj.pw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.modifymyinfoobj, "pw", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modifyUserdata"
  }, [_c('div', {
    staticClass: "modifyUserdata-str"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('password2')) + "：")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modifymyinfoobj.pw2),
      expression: "modifymyinfoobj.pw2"
    }],
    staticClass: "modifyUserdata-input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.modifymyinfoobj.pw2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.modifymyinfoobj, "pw2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modifyUserdata-msg",
    on: {
      "click": function($event) {
        _vm.modifyUser($event)
      }
    }
  }, [_c('span', {
    staticClass: "pay"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('complete')) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "modifyUserdata-err"
  }, [_c('span', [_vm._v(_vm._s(_vm.modifymyinfoobj.msg))])]), _vm._v(" "), _c('div', {
    staticClass: "modifyUserdata-openId"
  }, [_c('span', [_vm._v(_vm._s(_vm.$store.state.myinfo.openId))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-close",
    on: {
      "click": _vm.loginHide
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55dde2b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/modifymyinfo.vue
// module id = 468
// module chunks = 1